import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ArticleListing from '../../reusable/Articles/ArticleListing';
import entitiesApi from './../../api/Entities.api';
import api from './EntitiesNews.api';
import utils from './../../utils/utilities';
import reduxStore from './../../reduxStore';
import headerActions from './../../reusable/Header/Header.actions';
import { hashHistory } from 'react-router';
import {POST} from './../../constants';

const baseUrl = '/api/articles/riskEntity/';
const baseCountUrl = 'api/articles/count/riskEntity/';

class EntitiesNewsListingPage extends Component {

    constructor(props) {
        super(props);

        //this.filters = JSON.parse(props.routeParams.filters);
        this.companyId = utils.getQueryParam('companyId');
        this.riskLevel = reduxStore.getState().user.preferences.filters.riskFilter;
        this.pestle = reduxStore.getState().user.preferences.filters.pestleFilter;
        this.noOfDays  = utils.getQueryParam('noOfDays');

        this.articleClickHandler = this.articleClickHandler.bind(this);

    }

    componentDidMount() {
        headerActions.updateHeaderContent(' ');
        entitiesApi.specific([this.companyId]).then((companies) => {
            this.setState({ entityTitle: companies[0].companyTitle });
            headerActions.updateHeaderContent(
                <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.entityAllArticlesFromDays'
                                  values={{
                                      entityTitle: companies[0].companyTitle,
                                      daysNumber:  this.noOfDays
                                  }} />,
                'termsresultstips-field?lbu=US&locale=en_US&audience=all'
            );
        })
    }

    articleClickHandler(article, articleIndex) {
        const articleId = article.articleId;
        let location = window.location.href.substr(window.location.href.indexOf('#/') + 2);

        let config = {};
        config.headerKey = "getStartedDashboardEntityProfile";
        config.ttl = this.state.entityTitle;
        config.url = baseUrl + this.companyId;
        config.countUrl = baseCountUrl + this.companyId;
        config.urlParams = {
            companyId: this.companyId,
            pestle:    this.pestle,
            level:     this.riskLevel,
            noOfDays:  this.noOfDays,
            languages: utils.extractLanguagesFilter(reduxStore.getState().user.preferences.filters.languageFilter),
            timestamp: null
        };
        config.backRoute = location;
        config.verb = POST;

        hashHistory.push('/view-article/' + articleId + '/' + articleIndex + "?config=" + encodeURIComponent(JSON.stringify(config)));
    }

    render() {
        return <div className="trending-entities-page">
            <ArticleListing url={`${baseUrl}${this.companyId}`}
                            countUrl={`${baseCountUrl}${this.companyId}`}
                            urlParams={{
                                companyId: this.companyId,
                                pestle:    this.pestle,
                                level:     this.riskLevel,
                                noOfDays:  this.noOfDays,
                                languages: utils.extractLanguagesFilter(reduxStore.getState().user.preferences.filters.languageFilter),
                                timestamp: null
                            }}
                            showArticle={this.articleClickHandler}
                            filters={{ pestle: this.riskAngle, companyId: this.companyId }}
                            api={api}
                            helpUrl={'termsresultstips-field?lbu=US&locale=en_US&audience=all'} />
        </div>
    }
}

export default EntitiesNewsListingPage;



// WEBPACK FOOTER //
// ./src/scripts/pages/EntitiesNews/EntitiesNewsListingPage.jsx